import { t } from 'i18next';

export type P11Template = {
  cka_wrap: boolean;
  cka_unwrap: boolean;
  cka_decrypt: boolean;
  cka_encrypt: boolean;
  cka_sensitive: boolean;
  cka_modifiable: boolean;
  cka_extractable: boolean;
  cka_class: string;
  cka_local: boolean;
  cka_token: boolean;
  cka_sign: boolean;
  cka_verify: boolean;
  cka_private: boolean;
  cka_label: string;
};

export const getP11Label = (key: keyof P11Template) => {
  const labelsMap: Record<keyof P11Template, string> = {
    cka_class: t('pcks11.cka_class'),
    cka_label: t('pcks11.cka_label'),
    cka_token: t('pcks11.cka_token'),
    cka_sensitive: t('pcks11.cka_sensitive'),
    cka_encrypt: t('pcks11.cka_encrypt'),
    cka_decrypt: t('pcks11.cka_decrypt'),
    cka_wrap: t('pcks11.cka_wrap'),
    cka_unwrap: t('pcks11.cka_unwrap'),
    cka_sign: t('pcks11.cka_sign'),
    cka_verify: t('pcks11.cka_verify'),
    cka_private: t('pcks11.cka_private'),
    cka_modifiable: t('pcks11.cka_modifiable'),
    cka_extractable: t('pcks11.cka_extractable'),
    cka_local: t('pcks11.cka_local'),
  };

  return labelsMap[key] || key;
};
